<template>
  <v-list
    v-if="notificationList.length != 0"
    subheader
    two-line
    height="450"
    :style="{ 'overflow-y': scrollList }"
  >
    <v-list-item
      style="overflow-x: hidden"
      v-for="notification in notificationList"
      :key="notification.id"
      @click="
        $router.push({
          name: 'NotificationDetailView',
          params: {
            id: notification.id,
          },
        })
      "
    >
      <v-list-item-avatar>
        <template v-if="!isGroup(notification.managerRef)">
          <v-icon :class="getNotificationStatus(notification).color" dark>
            {{ getNotificationType(notification).icon }}
          </v-icon>
        </template>

        <template v-else>
          <v-tooltip top content-class="tooltip-no-transparency">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="{
                  ...on,
                  mouseenter: (e) => onActivatorMouseEnter(e, notification, on),
                }"
              >
                <AppAvatar
                  :userName="fullName(notification.manager)"
                  userAvatar=""
                  :isGroup="true"
                  avatarSize="34"
                  :initialsSize="11"
                  fab
                  small
                  iconSize="24"
                  avatarColor="primary"
                  initialsColor="secondary"
                  :showWarn="!notification.managerAccepted"
                  :overlapIconColor="notification.overlapIconColor"
                />
              </span>
            </template>
            <!-- Contenido del tooltip -->
            <div>
              <div>ID: {{ notification.id }}</div>
              <div>{{ $t('group') }}: {{ fullName(notification.manager) }}</div>
            </div>
            <div>
              {{ $t('waitGroupManager') }}
            </div>

            <!--Mostrar lista de operadores del grupo responsable -->
            <div>
              <div style="display: block; margin-top: 8px; margin-bottom: 10px">
                {{ $t('groupOperators') }}:
              </div>

              <!-- estado: cargando -->
              <div
                v-if="notification.groupAccess?.status !== 'ready'"
                class="tooltip-loading"
              >
                <v-progress-circular indeterminate size="20" width="2" />
              </div>

              <!-- estado: cargado -->
              <template v-else>
                <!-- si hay hay operadores -->
                <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                <ul v-if="getGroupOperators(notification).length">
                  <li
                    v-for="(operator, index) in getGroupOperatorsPreview(
                      notification
                    )"
                    :key="index"
                  >
                    <v-row align="center">
                      <AppAvatar
                        class="mr-2 mt-3 mb-3"
                        :userName="operator.fullName"
                        :userAvatar="operator.avatarURL"
                        avatarSize="34"
                        :initialsSize="11"
                        iconSize="24"
                        avatarColor="primary"
                        initialsColor="secondary"
                        :showWarn="
                          notification.groupAccess.map[operator.id]?.hasError
                        "
                        :overlapIconColor="
                          notification.groupAccess.map[operator.id]?.hasError
                            ? 'error'
                            : undefined
                        "
                      />

                      <span class="mr-2 mt-3 mb-3">
                        {{ operator.fullName }} :
                        {{ operatorAccessText(operator, notification) }}
                        <template
                          v-if="
                            notification.groupAccess?.map[operator.id]?.response
                              .responded
                          "
                        >
                          <v-icon
                            :color="
                              notification.groupAccess.map[operator.id].response
                                .color
                            "
                            size="15"
                            class="ml-1 mb-1"
                          >
                            mdi-circle
                          </v-icon>
                          {{
                            notification.groupAccess.map[operator.id].response
                              .text
                          }}
                        </template>
                      </span>
                    </v-row>
                  </li>
                  <br />
                </ul>
                <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                <div
                  v-if="
                    getGroupOperators(notification).length > maxOperatorsPreview
                  "
                  class="group-operators-info"
                >
                  <v-chip
                    small
                    _color="grey lighten-4"
                    _text-color="grey darken-3"
                    color="primary"
                    text-color="seconday"
                    class="operator-count-chip"
                  >
                    +{{
                      getGroupOperators(notification).length -
                      maxOperatorsPreview
                    }}
                  </v-chip>
                  <span class="operator-count-text">{{
                    $t('groupOperators')
                  }}</span>
                </div>

                <!-- estado: cargado pero grupo vacio -->
                <div v-if="!getGroupOperators(notification).length">
                  <ul>
                    <li>{{ $t('withoutOperators') }}</li>
                  </ul>
                </div>
              </template>
            </div>
          </v-tooltip>
        </template>
      </v-list-item-avatar>

      <v-list-item-content class="concept-text">
        {{ notification.concepto }}
      </v-list-item-content>

      <v-list-item-action class="notification-actions">
        <v-btn
          color="accept"
          icon
          plain
          @click.stop="() => acceptNotification(notification)"
          id="accept-responsability"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn
          color="error"
          icon
          plain
          @click.stop="() => declineNotification(notification)"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
  <v-container v-else style="text-align: center">
    <b>
      <span> {{ $t('emptyTypeNotificationList') }} </span>
    </b>
  </v-container>
</template>
<script>
import {
  getNotificationStatus,
  getNotificationType,
  managerAcceptNotification,
  managerDeclineNotification,
  canOperatorBeManager,
  canOperatorBeManagerWithFilters,
  saveOperatorResponse,
} from '@/services/notification-service'
import {
  getOperatorsSubscriptionReduced,
  withHeavyCache,
  clearOperatorsHeavyCache,
  GetDocumentFromReference,
} from '@/services/operator-service'
import { getGroupsSubscription } from '@/services/groups-service'
import { isGroupRef } from '@/services/user-service'
import { mapGetters } from 'vuex'

export default {
  props: {
    notificationList: {
      type: Array,
    },
  },
  data() {
    return {
      operatorsUnsubscribe: () => {},
      groupsUnsubscribe: () => {},
      operators: [],
      groups: null,
    }
  },
  methods: {
    getNotificationStatus(notification) {
      return getNotificationStatus(notification)
    },
    getNotificationType(notification) {
      return getNotificationType(notification)
    },
    async acceptNotification(notification) {
      if (this.isGroup(notification.managerRef)) {
        await saveOperatorResponse(notification.id, true)
      } else {
        await managerAcceptNotification(notification.id)
      }
    },
    async declineNotification(notification) {
      if (this.isGroup(notification.managerRef)) {
        await saveOperatorResponse(notification.id, false)
      } else {
        await managerDeclineNotification(notification.id)
      }
    },
    fullName(obj, nameKey = 'name', surnameKey = 'surname') {
      if (!obj) return ''
      if (obj.fullName) return obj.fullName

      return [obj[nameKey], obj[surnameKey]]
        .filter((value) => typeof value === 'string' && value.trim() !== '')
        .join(' ')
    },
    isGroup(ref) {
      return isGroupRef(ref)
    },
    async canOperatorAccessToNotification(operator, notification) {
      // Segun las especificaciones de la tarea GOODOK-2039 si el responsable es un grupo y el operador
      // pertenece a ese grupo debe tomar en cuenta solo las empresas, y no aplicar tambien los filtros.
      const canBeManager = this.isGroup(notification.managerRef)
        ? canOperatorBeManager(withHeavyCache(operator), notification)
        : await canOperatorBeManagerWithFilters(
            withHeavyCache(operator),
            notification
          )

      return canBeManager && !operator.disabled
    },
    async loadGroupData(
      item,
      { forceReset = false, showLoading = false } = {}
    ) {
      if (!item.managerRef) {
        item.overlapIconColor = undefined
        return
      }

      // Bloqueo por item, evitar concurrencias
      if (item._loadingGroupData) return

      if (this.isGroup(item.managerRef)) {
        if (!item._groupState) {
          this.$set(item, '_groupState', {
            loading: false,
            operatorsLoaded: false,
            tooltipReady: false,
            accessReady: false,
          })
        }

        this.$set(item, '_loadingGroupData', true)
        item._groupState.loading = true
        item._groupState.tooltipReady = false
      }

      if (!item.overlapIconColor) {
        this.$set(item, 'overlapIconColor', 'loading')
      }

      try {
        // En el reproceso mostrar el icono loading
        if (!forceReset && showLoading) {
          ////this.$set(item, 'isReprocessing', true)
        }

        if (!this.isGroup(item.managerRef)) {
          // Añadir nueva propiedad reactiva solo para los usuarios, no grupos
          this.$set(item, 'canBeManager', null)

          // La notificacion tiene un responsable operador, no un grupo.
          // Puede haber algun caso en el que el operador este disabled (ya contemplado), pero tambien puede
          // ocurrir que al operador asignado le quiten la empresa y deje de ver la notificacion, en cuyo caso
          // hay que mostrar, a los usuarios admin, un triangulo rojo en el avatar del responsable.
          const operator =
            this.operatorsMap[item.managerRef.id] ??
            (await GetDocumentFromReference(item.managerRef))

          item.canBeManager = canOperatorBeManager(
            withHeavyCache(operator),
            item
          )
          this.updateOverlapIconColor(item) // Estado del avatar del operador
          return
        }

        // Es un Grupo
        // Si ya esta cargado volver a calcular los permisos igualmente, no guardar nada en cache
        // Estado inicial, aun no cargado (reactivo)
        if (forceReset) {
          item._groupState.operatorsLoaded = false
        }

        try {
          // Calcular el acceso a la notificacion
          await this.loadGroupOperatorsAccess(item)

          item._groupState.operatorsLoaded = true
          item._groupState.tooltipReady = true
          item._groupState.loading = false

          if (!this.getGroupOperators(item).length) {
            this.$set(item, 'groupAccess', {
              status: 'ready',
              map: {},
              summary: {
                hasAnyAccess: false,
                hasPending: false,
                rejectedAll: true,
              },
            })
            item.overlapIconColor = 'error'
            return
          }

          this.updateOverlapIconColor(item) // Estado del avatar del grupo
        } catch (e) {
          console.error(
            'Item id: ' +
              item.id +
              ' , Error cargando accesos de los operadores del grupo: ',
            this.groupsOperatorsMap[item.managerRef.id]?.name,
            e
          )
          item._groupState.operatorsLoaded = true
          item._groupState.tooltipReady = true
          item._groupState.loading = false
          item.overlapIconColor = 'error'
        }
      } finally {
        item._loadingGroupData = false
      }
    },
    async loadGroupOperatorsAccess(item) {
      if (!item.managerRef) return
      if (!this.isGroup(item.managerRef)) return

      const entry = this.groupsOperatorsMap[item.managerRef.id]
      // grupos todavia no cargados en el mapa
      if (!entry) {
        return
      }
      const operatorIds = entry?.operatorIds ?? []
      const operators = operatorIds
        .map((id) => this.operatorsMap[id])
        .filter(Boolean)

      // limpiar e iniciar loading
      if (!item.groupAccess) {
        this.$set(item, 'groupAccess', {
          status: 'loading',
          map: {},
          summary: {},
        })
      }

      /* INFORMACION
       * Nuevo objeto ligero en cada notificacion, se define como sigue:
       * groupAccess = {
       *    status: puede ser 'loading' | 'ready' | 'error',
       *    map: [operatorId]
       *      { canAccess: boolean,
       *        hasError: boolean,
       *        response: {
       *          responded: boolean,
       *          accepted: boolean | null,
       *          lastResponseAt: timestamp | null,
       *          color,
       *          text,
       *        }
       *    },
       *    summary: {
       *      eligibleCount,
       *      hasAnyAccess,
       *      hasPending,
       *      rejectedAll,
       *      acceptedOperatorDeletedFromGroup,
       *      acceptedOperatorDeletedFromGroupFullname,
       *      lastAcceptedStillValid
       *      hasAccepted
       *    }
       * }
       *
       */

      try {
        const accessMap = {}
        // 1. acceso por operador
        // Procesado secuencial (no Promise.all)
        const responses = item?.responseOperators || []
        const responsesByOperator = {}

        for (const r of responses) {
          const prev = responsesByOperator[r.userRef.id]

          if (!prev || r.createdAt > prev.createdAt) {
            responsesByOperator[r.userRef.id] = {
              response: r.response,
              createdAt: r.createdAt,
            }
          }
        }

        for (const operator of operators) {
          const canAccess = await this.canOperatorAccessToNotification(
            operator,
            item
          )

          const responseInfo = responsesByOperator[operator.id] || null

          let color = ''
          if (operator.disabled) {
            color = ''
          } else if (responseInfo) {
            color = responseInfo.response === false ? 'error' : 'success'
          }

          let text = ''
          if (responseInfo) {
            if (responseInfo.response === false) {
              text = this.$t('operatorResponsabilityRejected')
            } else if (responseInfo.response === true) {
              text = this.$t('operatorResponsabilityAccepted')
            }

            if (responseInfo.createdAt) {
              // esta almacenada en milisegundos
              text += ' (' + this.formatDate(responseInfo.createdAt) + ')'
            }
          }

          accessMap[operator.id] = {
            canAccess,
            hasError: operator.disabled || canAccess !== true,
            response: {
              responded: !!responseInfo,
              accepted: responseInfo ? responseInfo.response : null,
              lastResponseAt: responseInfo ? responseInfo.createdAt : null,
              color,
              text,
            },
          }
        }

        // 2. elegibles, son lo que pueden acceder
        const eligibleOperators = operators.filter(
          (op) => !op.disabled && accessMap[op.id].canAccess === true
        )

        const eligibleCount = eligibleOperators.length

        // 3. pendientes
        const respondedIds = responses.map((r) => r.userRef.id)
        const hasPending = eligibleOperators.some(
          (op) => !respondedIds.includes(op.id)
        )

        // 4. rechazados globales
        const rejectedAll =
          eligibleOperators.length > 0 &&
          eligibleOperators.every((op) =>
            responses.some(
              (r) => r.userRef.id === op.id && r.response === false
            )
          )

        // 5. ultimo aceptado
        const acceptedOperators = responses
          .filter((r) => r.response === true)
          .sort((a, b) => b.createdAt - a.createdAt)

        let acceptedOperatorDeletedFromGroup = false
        let acceptedOperatorDeletedFromGroupFullname = ''
        let lastAcceptedStillValid = false

        if (acceptedOperators.length > 0) {
          const lastAccepted = acceptedOperators[0]

          const stillInGroup = operators.some(
            (op) => op.id === lastAccepted.userRef.id
          )

          acceptedOperatorDeletedFromGroup = !stillInGroup

          // Guardar el nombre del operador que aceptó y que ya no se encuentra en el grupo, para mostrarlo en el tooltip
          if (!stillInGroup) {
            const oper = this.operators.find(
              (op) => op.id === lastAccepted.userRef.id
            )

            if (oper) {
              acceptedOperatorDeletedFromGroupFullname = this.fullName(oper)
            }
          }

          const accessOk = stillInGroup
            ? accessMap[lastAccepted.userRef.id].canAccess
            : false

          lastAcceptedStillValid = stillInGroup && accessOk
        }

        // hay alguien que tenga acceso ?
        const hasAnyAccess = eligibleOperators.length > 0

        // 6. commit final (una sola mutación reactiva)
        this.$set(item, 'groupAccess', {
          status: 'ready',
          map: accessMap,
          summary: {
            eligibleCount,
            hasAnyAccess,
            hasPending,
            rejectedAll,
            acceptedOperatorDeletedFromGroup,
            acceptedOperatorDeletedFromGroupFullname,
            lastAcceptedStillValid,
            hasAccepted: acceptedOperators.length > 0,
          },
        })
      } catch (e) {
        console.error('Error comprobando accesos del grupo', e)

        this.$set(item, 'groupAccess', {
          status: 'error',
          map: null,
          summary: null,
        })
      }
    },
    operatorAccessText(operator, item) {
      const groupAccess = item.groupAccess

      // estado del grupo
      if (!groupAccess || groupAccess.status === 'loading') {
        return this.$t('processing')
      }

      if (groupAccess.status === 'error') {
        return this.$t('operatorAccessNotificationKO')
      }

      if (operator.disabled) return this.$t('operatorDisabled')

      const canAccess = groupAccess.map?.[operator.id]?.canAccess
      return canAccess
        ? '' //this.$t('operatorAccessNotificationOK') // por defecto, si tiene acceso no pinta ningun texto
        : this.$t('operatorAccessNotificationKO')
    },
    onActivatorMouseEnter(e, item, on) {
      on.mouseenter(e) // asegura que Vuetify abra el tooltip
      // eliminar la recarga y utilizar la info cargada previamente en la propia notificacion
      //this.managerTooltipMouseEnter(item) // dispara la carga personalizada en paralelo
    },
    calculateOverlapIconColor(item) {
      if (!item.manager) return undefined

      // Si no es grupo, comportamiento normal de usuario
      if (!this.isGroup(item.managerRef)) {
        return item.manager?.disabled || item.canBeManager === false
          ? 'error'
          : !item.managerAccepted
          ? 'warning'
          : undefined
      }

      // Es un grupo, pero esta eliminado
      if (item.manager.deleted) return 'error'

      const groupAccess = item.groupAccess

      // Mientras se carga cualquier cosa del grupo: muestra el spinner
      if (!groupAccess || groupAccess.status !== 'ready') {
        return 'loading'
      }

      const operators = this.getGroupOperators(item)

      if (!operators.length) {
        return 'error'
      }

      const s = groupAccess.summary
      if (!s) return 'loading'

      // Nadie puede acceder
      if (!s.hasAnyAccess) return 'error'

      // Aceptó alguien y sigue siendo valido: ok, sin icono
      if (s.hasAccepted && s.lastAcceptedStillValid) {
        return undefined
      }

      // Aceptó alguien pero ya no es valido
      if (s.hasAccepted && !s.lastAcceptedStillValid) {
        return 'error'
      }

      // Hay pendientes
      if (s.hasPending) {
        return 'warning'
      }

      // Caso final: nadie pendiente y nadie aceptado valido
      return 'error'
    },
    getLatestOperatorResponse(notification, operator) {
      return this.getOperatorResponses(notification, operator)?.latest ?? null
    },
    getOperatorResponses(notification, operator) {
      // ahora un operador puede tener mas de una respuesta (p.e. rechazar y despues aceptar)
      // devuelve el objeto con la info necesaria: quién, qué y cuándo
      if (!notification.responseOperators?.length) {
        return { latest: null, history: [] }
      }

      const responses = notification.responseOperators
        .filter((r) => r.userRef.id === operator.id)
        .slice() // copia defensiva, evita mutar el array original
        .sort((a, b) => b.createdAt - a.createdAt) // mas reciente arriba

      return {
        latest: responses[0] ?? null,
        history: responses.slice(1),
      }
    },
    formatDate(ts) {
      if (!ts) return ''
      const d = new Date(ts)
      const pad = (n) => String(n).padStart(2, '0')

      return (
        `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
        //`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      )
    },
    hasGroupChanged(prev, curr) {
      if (prev.name !== curr.name) return true
      if (prev.deleted !== curr.deleted) return true

      if (
        JSON.stringify(this.normalizeArray(prev.cifsRef)) !==
        JSON.stringify(this.normalizeArray(curr.cifsRef))
      )
        return true

      if (
        JSON.stringify(this.normalizeArray(prev.filtersRef)) !==
        JSON.stringify(this.normalizeArray(curr.filtersRef))
      )
        return true

      if (
        JSON.stringify(this.normalizeArray(prev.usersRef)) !==
        JSON.stringify(this.normalizeArray(curr.usersRef))
      )
        return true

      return false
    },
    normalizeArray(arr) {
      // Normaliza los arrays de referencias:
      // - Extrae id si es una referencia
      // - Ordena para evitar cambios de orden irrelevantes
      if (!Array.isArray(arr)) return []
      return arr.map((item) => item?.id ?? item).sort()
    },
    updateOverlapIconColor(item) {
      const color = this.calculateOverlapIconColor(item)
      if (item.overlapIconColor !== color) {
        this.$set(item, 'overlapIconColor', color)
      }
    },
    getGroupOperators(item) {
      if (!item?.managerRef || !this.isGroup(item.managerRef)) return []

      const entry = this.groupsOperatorsMap[item.managerRef.id]
      if (!entry?.operatorIds?.length) return []

      return entry.operatorIds
        .map((id) => this.operatorsMap[id])
        .filter(Boolean)
    },
    getGroupOperatorsPreview(item) {
      const operators = this.getGroupOperators(item)
      // primero ordenar y luego hacer el slice
      return this.sortOperatorsByFullName(operators).slice(
        0,
        this.maxOperatorsPreview
      )
    },
    sortOperatorsByFullName(operators = []) {
      // ordenar por nombre, sin mutar el array original.
      return [...operators].sort((a, b) =>
        a.fullName.localeCompare(b.fullName, 'es', { sensitivity: 'base' })
      )
    },
  },
  computed: {
    ...mapGetters(['maxOperatorsPreview', 'isOperatorUser']),
    scrollList() {
      return this.notificationList.length > 5 ? 'scroll' : 'hidden'
    },
    notifications() {
      return this.notificationList
    },
    operatorsMap() {
      const map = {}
      for (const operator of this.operators || []) {
        map[operator.id] = operator
      }
      return map
    },
    groupsOperatorsMap() {
      const map = {}
      if (!this.groups?.length) return map

      for (const group of this.groups || []) {
        // guardamos solo los ids de los operadores del grupo y un par de metadatos, nada de objetos
        map[group.id] = {
          operatorIds: (group.usersRef || []).map((ref) => ref.id),
          deleted: group.deleted,
          name: group.fullName,
        }
      }
      return map
    },
  },
  async destroyed() {
    if (this.operatorsUnsubscribe) {
      this.operatorsUnsubscribe()
      clearOperatorsHeavyCache()
    }
    if (this.groupsUnsubscribe) this.groupsUnsubscribe()
  },
  async created() {
    const userId = this.isOperatorUser
      ? this.$store.state.user.parentRef.id
      : this.$store.state.user.id

    this.operatorsUnsubscribe = await getOperatorsSubscriptionReduced(
      userId,
      this
    )

    this.groupsUnsubscribe = await getGroupsSubscription(this)
  },
  watch: {
    notificationList: {
      immediate: true,
      handler(newList, oldList) {
        if (!Array.isArray(newList) || !Array.isArray(oldList)) {
          return
        }

        // Detectar una recarga completa de las notificaciones en el store
        if (this.$store.state.notificationsReloaded === true) {
          for (const item of newList) {
            this.loadGroupData(item, { forceReset: true, showLoading: true })
          }
          // Eliminar el flag
          this.$store.commit('consumeNotificationsReloaded')
          return
        }

        // Si no se trata de una recarga desde el store
        const oldMap = new Map(oldList.map((o) => [o.id, o]))

        for (const item of newList) {
          const oldItem = oldMap.get(item.id)

          // nuevo item
          if (!oldItem) {
            this.loadGroupData(item, { forceReset: true, showLoading: true })
            continue
          }

          // cambios realmente relevantes
          if (
            item.managerAccepted !== oldItem.managerAccepted ||
            (item.responseOperators?.length ?? 0) !==
              (oldItem.responseOperators?.length ?? 0) ||
            item.manager?.disabled !== oldItem.manager?.disabled ||
            item.manager?.deleted !== oldItem.manager?.deleted
          ) {
            this.loadGroupData(item, { forceReset: false, showLoading: true })
          }
        }
      },
    },
    operators: {
      async handler(newVal, oldVal) {
        if (!oldVal || newVal === oldVal) return
        // los operadores suscritos han cambiado, recalcula colores de los avatares de operadores
        // averiguar qué operador ha cambiado y en que afecta (name, surname, disabled ...) porque la
        // mayoria de atributos no influyen en esto
        let changed = null
        for (const op of newVal) {
          const prev = oldVal.find((item) => item.id === op.id)
          if (!prev) {
            // operador nuevo, añadido
            continue
          }

          const prevMap = prev.cifsPermissions || {}
          const nextMap = op.cifsPermissions || {}
          // Detectar borrado de claves en el mapa cifsPermissions, lo que significa empresa borrada al operador
          const removed = Object.keys(prevMap).filter((k) => !(k in nextMap))
          // Detectar nuevas claves en el mapa cifsPermissions, lo que significa empresa añadida al operador
          const added = Object.keys(nextMap).filter((k) => !(k in prevMap))

          if (
            prev.name !== op.name ||
            prev.surname !== op.surname ||
            prev.disabled !== op.disabled ||
            removed.length > 0 ||
            added.length > 0
          ) {
            changed = op
            break
          }
        }
        if (!changed) return

        const operatorsMap = this.operatorsMap

        // Caso el responsable es un operador:
        //  - filtrar aquellas notificaciones cuyo managerRef.id sea === al id del operador que ha cambiado,
        // Caso el responsable es un grupo:
        //  - Si cambia un operador
        //  - Y ese operador pertenece a un grupo responsable
        //  - Recalcular solo esas notificaciones
        //
        // y luego actualizar unicamente ese conjunto de notificaciones, no todas.
        const affectedNotifications = this.notifications.filter((item) => {
          if (!item.managerRef) return false

          // Caso 1: operador es responsable directo
          if (item.managerRef.id === changed.id) return true

          // Caso 2: responsable es grupo y el operador pertenece al grupo cargado
          if (
            this.isGroup(item.managerRef) &&
            this.getGroupOperators(item).some((op) => op.id === changed.id)
          ) {
            return true
          }

          return false
        })

        await Promise.all(
          affectedNotifications.map(async (doc) => {
            // Si el responsable es operador, se actualiza manager
            if (!this.isGroup(doc.managerRef)) {
              const newManager =
                operatorsMap[doc.managerRef.id] ??
                (await GetDocumentFromReference(doc.managerRef))

              doc.manager = newManager
              // actualiza el cambio en el store mediante una nueva mutacion
              this.$store.commit('updateNotificationManager', {
                id: doc.id,
                manager: newManager,
              })
            }

            // En ambos casos (operador directo o grupo)
            return this.loadGroupData(doc, {
              forceReset: false,
              showLoading: true,
            })
          })
        )
      },
    },
    groups: {
      async handler(newVal, oldVal) {
        if (!Array.isArray(newVal) || !Array.isArray(oldVal)) {
          return
        }
        // los grupos suscritos han cambiado, recalcula colores de los avatares de grupos
        // averiguar qué grupo ha cambiado y en que afecta (name, deleted, arrays de referencias ...)
        let changed = null

        for (const grp of newVal) {
          const prev = oldVal.find((item) => item.id === grp.id)
          if (!prev) {
            // grupo nuevo, añadido
            continue
          }

          if (this.hasGroupChanged(prev, grp)) {
            changed = grp
            break
          }
        }
        if (!changed) return

        const groupsById = {}
        for (const g of this.groups) {
          groupsById[g.id] = g // a diferencia del mapa groupsOperatorsMap, esto si contiene todo el objeto completo suscrito.
        }

        await Promise.all(
          this.notifications
            .filter((item) => item.managerRef?.id === changed.id)
            .map(async (doc) => {
              const newManager =
                groupsById[doc.managerRef.id] ??
                (await GetDocumentFromReference(doc.managerRef))

              doc.manager = newManager
              // actualiza el cambio en el store mediante una nueva mutacion
              this.$store.commit('updateNotificationManager', {
                id: doc.id,
                manager: newManager,
              })

              return this.loadGroupData(doc, {
                forceReset: false,
                showLoading: false,
              })
            })
        )
      },
    },
    groupsOperatorsMap: {
      immediate: true,
      handler(map) {
        if (!map) return
        this.notifications.forEach((item) => {
          if (item.managerRef) {
            this.loadGroupData(item, { forceReset: true, showLoading: true })
          }
        })
      },
    },
  },
}
</script>
<style lang="scss" scoped>
/* tooltip de grupo: color gris un poco mas oscuro y eliminar la transparencia */
.tooltip-no-transparency {
  background-color: rgba(97, 97, 97, 1) !important; /* opaco */
  opacity: 1 !important; /* sin transparencia */
  color: #ffffff; /* texto base legible */
}

.group-operators-info {
  display: flex;
  align-items: center; /* Alinea chip y texto verticalmente */
  margin-top: 12px; /* Igual que mt-3 */
  padding-left: 8px; /* Ajusta al borde izquierdo del tooltip */
}

.operator-count-chip {
  margin-right: 8px; /* espacio entre chip y texto */
}

.operator-count-text {
  font-size: 0.875rem; /* Igual que body-2, ajustable */
  color: #ffffff; /* texto base legible */
}

.tooltip-loading {
  min-width: 260px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* el avatar de grupo cuadrado y el warning desaparecia parcialmente, asi se soluciona */
::v-deep .v-list-item__avatar {
  overflow: visible;
}

/* al colocar los botones en un -action se situaban uno debajo de otro, asi se soluciona */
.notification-actions {
  flex-direction: row;
  align-items: center;
}

/* para separacion de ambos botones */
.notification-actions .v-btn {
  margin-left: 6px;
}

/* Para evitar que el texto empuje a los botones en pantallas pequeñas */
.v-list-item__content {
  overflow: hidden;
}

/* se elimina el metodo que recortaba la longitud del concepto y se sustituye por esta clase, responsive */
.concept-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
